import { Injectable } from '@angular/core';
import { ThemeService } from 'rev-portal/branding/Theme.Service';

let nextId = 0;
@Injectable({
	providedIn: 'root'
})
export class VbTitleService {
	private readonly titles: Array<{ id: number; value: string }> = [];

	constructor(
		private readonly ThemeService: ThemeService
	) {
		this.ThemeService.brandingSettings$.subscribe(() => this.syncTitle());
	}

	public addTitle(title: string): number {
		const id = nextId++;
		this.titles.push({ id, value: title });
		this.syncTitle();

		return id;
	}

	public removeTitle(id: number): void {
		const titleIndex = this.titles.findIndex(title => title.id === id);
		if(titleIndex >= 0) {
			this.titles.splice(titleIndex, 1);
			this.syncTitle();
		}
	}

	public updateTitle(id: number, title: string): void {
		const t = (this.titles || []).find(title => title.id === id);

		if (t) {
			t.value = title;
		}

		this.syncTitle();
	}

	private syncTitle(): void {
		const systemTitle = this.ThemeService.brandingSettings.themeSettings.systemTitle;
		const title = this.titles.length ? this.titles[this.titles.length - 1].value : '';
		document.title = title ? `${title} - ${systemTitle}` : systemTitle;
	}
}
